import './Select.scss';

import React from 'react';

Select.defaultProps = {
    className: '',
    name: 'select',
    firstOption: 'Veuillez choisir une option', // FIXME: traduction
    value: '',
    required: false,
    elements: [],
    displayAttribute: '',
    lang: 'fr_CA',
    selectType: 'simple',
};

const simpleOption = (element: any) => {
    return <option key={element}>{element}</option>;
};

const arrayOption = (element: any) => {
    return (
        <option value={element[0]} key={element[0]}>
            {element[1]}
        </option>
    );
};

const objectOption = (element: any, props: any, index: any) => {
    if (element[props.displayAttribute]) {
        return (
            <option key={index}>
                {element?.code && `${element?.code} - `}
                {element[props.displayAttribute]?.[props.lang]}
            </option>
        );
    } else return undefined;
};

export default function Select(props: any) {
    const {
        value,
        name,
        error,
        required,
        validateInput,
        firstOption,
        selectType,
        className,
        elements,
        onChange,
        disabled,
    } = props;

    return (
        <>
            <select
                disabled={disabled}
                value={value}
                name={name}
                className={
                    error ? `select error ${className}` : `select ${className}`
                }
                required={required}
                onChange={(event) => onChange(event.currentTarget.value)}
                onBlur={validateInput ? () => validateInput() : undefined}
            >
                {firstOption && (
                    <option defaultValue={'true'} hidden>
                        {firstOption}
                    </option>
                )}
                {selectType === 'product' && (
                    <option disabled>{firstOption}</option>
                )}

                {elements.map((element: any, index: any) => {
                    switch (selectType) {
                        case 'simple':
                            return simpleOption(element);
                        case 'product':
                            return objectOption(element, props, index);
                        case 'array':
                            return arrayOption(element);
                        default:
                            return undefined;
                    }
                })}
            </select>
            <span
                className='inputError'
                style={{ display: error ? 'inline' : 'none' }}
            >
                {error}
            </span>
        </>
    );
}
